"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@nextui-org/react");
var multiTextInput_1 = __importDefault(require("../../../../../../../../controls/multiTextInput"));
var ProductAttributeFamiliesInput = function (_a) {
    var _b = _a.initialProductFamily, initialProductFamily = _b === void 0 ? {} : _b, _c = _a.attributeFamilyList, attributeFamilyList = _c === void 0 ? [] : _c, onChange = _a.onChange;
    var _d = (0, react_1.useState)(), productFamilyData = _d[0], setProductFamilyData = _d[1];
    (0, react_1.useEffect)(function () {
        if (!productFamilyData) {
            setProductFamilyData(initialProductFamily);
        }
    }, [initialProductFamily]);
    var renderTypeField = function (_a) {
        var attr = _a.attr, index = _a.index;
        switch (attr === null || attr === void 0 ? void 0 : attr.type) {
            case "TEXT":
                return ((0, jsx_runtime_1.jsx)(react_2.Input, { label: "Default Value", placeholder: "Enter default text value", value: attr === null || attr === void 0 ? void 0 : attr.default_value, onChange: function (e) { return handleAttributeChange(index, "TEXT", e.target.value); }, className: "max-w-full" }));
            case "NUMBER":
                return ((0, jsx_runtime_1.jsx)(react_2.Input, { type: "number", label: "Default Value", placeholder: "Enter default numeric value", value: attr === null || attr === void 0 ? void 0 : attr.default_value, onChange: function (e) { return handleAttributeChange(index, "NUMBER", e.target.value); }, className: "max-w-full" }));
            case "BOOLEAN":
                return ((0, jsx_runtime_1.jsxs)(react_2.Select, __assign({ label: "Default Value", placeholder: "Select default boolean value", selectedKeys: [attr === null || attr === void 0 ? void 0 : attr.default_value], onChange: function (e) { return handleAttributeChange(index, "BOOLEAN", e.target.value); }, className: "max-w-full" }, { children: [(0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: "true" }, { children: "True" }), "true"), (0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: "false" }, { children: "False" }), "false")] })));
            case "LIST":
                return (0, jsx_runtime_1.jsx)(multiTextInput_1.default, { options: attr === null || attr === void 0 ? void 0 : attr.options, callback: function (options) { return handleAttributeChange(index, "LIST", options); } });
            default:
                return null;
        }
    };
    var handleAddProductAttributeFamily = function (value) {
        setProductFamilyData(value);
        onChange(value);
    };
    var handleRemoveAttribute = function (_id) {
        var attributeIndex = productFamilyData.attributes.filter(function (_, i) { return _._id !== _id; });
        productFamilyData.attributes.splice(attributeIndex, 1);
        setProductFamilyData(productFamilyData);
        onChange(productFamilyData);
    };
    var handleAttributeChange = function (index, type, newValue) {
        var _a;
        var updatedAttributes = (_a = productFamilyData === null || productFamilyData === void 0 ? void 0 : productFamilyData.attributes) === null || _a === void 0 ? void 0 : _a.map(function (attr, i) {
            if (i === index) {
                if (type === "LIST") {
                    return __assign(__assign({}, attr), { type: type, options: newValue });
                }
                return __assign(__assign({}, attr), { type: type, default_value: newValue });
            }
            return attr;
        });
        setProductFamilyData(__assign(__assign({}, productFamilyData), { attributes: updatedAttributes }));
        onChange(__assign(__assign({}, productFamilyData), { attributes: updatedAttributes }));
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "space-y-4" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "px-4 pb-2" }, { children: (0, jsx_runtime_1.jsx)(react_2.Select, __assign({ label: "Select an attribute family", className: "w-80", items: attributeFamilyList, onChange: function (e) {
                    var selectedId = e.target.value;
                    var selectedOption = attributeFamilyList.find(function (opt) { return opt._id === selectedId; });
                    handleAddProductAttributeFamily(selectedOption);
                } }, { children: function (family) { return (0, jsx_runtime_1.jsx)(react_2.SelectItem, { children: family.name }, family._id); } })) })) })));
};
exports.default = ProductAttributeFamiliesInput;
